import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getAlertGuidances,
  createAlertGuidance,
  updateAlertGuidance,
  deleteAlertGuidance,
  type AlertGuidance,
} from '../../services';

export const alertGuidanceKeys = {
  all: ['alertGuidance'] as const,
  lists: () => [...alertGuidanceKeys.all, 'list'] as const,
  list: (alertTypeId: number) =>
    [...alertGuidanceKeys.lists(), alertTypeId] as const,
};

export function useAlertGuidances(alertTypeId: number) {
  return useQuery({
    queryKey: alertGuidanceKeys.list(alertTypeId),
    queryFn: () => getAlertGuidances(alertTypeId),
    enabled: !!alertTypeId,
  });
}

export function useCreateAlertGuidance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAlertGuidance,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: alertGuidanceKeys.list(data.alert_type),
      });
    },
  });
}

export function useUpdateAlertGuidance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: AlertGuidance }) =>
      updateAlertGuidance(id, data),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: alertGuidanceKeys.list(data.alert_type),
      });
    },
  });
}

export function useDeleteAlertGuidance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAlertGuidance,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: alertGuidanceKeys.lists(),
      });
    },
  });
}
